var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-10 border p-20 h-100"},[_c('div',{staticClass:"border h-100 overflow-hidden"},[_c('iframe',{staticClass:"border-0 h-100 w-100",attrs:{"src":_vm.file}})])])}
var staticRenderFns = []

export { render, staticRenderFns }